import React, { useMemo } from 'react';
import classNames from 'classnames';

export default function Alert({
                                  id,
                                  content = '',
                                  loading = false,
                                  appearance = 'default',
                                  onCloseCallback = Function.prototype,
                              }) {
    const cls = useMemo(
        () =>
            classNames('alert', {
                [`alert-${appearance}`]: appearance !== 'default',
            }),
        [appearance]
    );

    return (
        <div className={cls} role="alert">
            <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={() => onCloseCallback(id)}
            >
                <span aria-hidden="true">×</span>
            </button>

            <div
                className="alert__content"
                dangerouslySetInnerHTML={{ __html: content || '' }}
            />
            {loading ? <div className="alert__loading" /> : null}
        </div>
    );
}
